<template>
  <div>
    <el-dialog
      title=""
      :visible.sync="searchVisible"
      width="1400px"
      >
      <div class="main-content">
        <div class="content-left">
          <div class="left-title">{{ searchDialogData.title }}检索</div>
          <div class="left-search">
            <div style="width: 300px;margin-right: 10px; ">
              <el-input
                placeholder="请输入标签内容检索"
                v-if="searchDialogData.title=='标签'"
                v-model="keyword"
                clearable>
              </el-input>
              <el-input
                placeholder="请输入人物名称检索"
                v-if="searchDialogData.title=='人物'"
                v-model="name"
                clearable>
              </el-input>
            </div>
            <el-button type="primary" @click="goSearch(1)">搜索</el-button>
            <el-button type="danger" @click="goSearch(0)">清空</el-button>
          </div>
          <div class="left-content" >
            <el-checkbox-group v-loading="loading" @change="checkboxChange" v-if="searchDialogData.title=='标签'" class="left-content-checkbox-group" v-model="dataIdList">
              <el-checkbox class="left-content-checkbox" v-for="label in filterDataList" :key="label.id" :label="label.id">{{ label.labelName||label.peopleName }}</el-checkbox>
            </el-checkbox-group>
            <el-tabs  v-if="searchDialogData.title=='人物'" v-model="peopleClassValue" @tab-click="handleClick">
              <el-tab-pane v-for="(key,index) in peopleClassKey" :key="index" :label="key" :name="key">
                  <div class="people-class" v-loading="loading" v-if="filterDataList.length>0">
                    <el-checkbox-group class="left-content-checkbox-group" v-model="dataIdList">
                      <el-checkbox class="left-content-checkbox" v-for="label in filterDataList" :key="label.id" :label="label.id">{{ label.labelName||label.peopleName }}</el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div class="people-class" v-loading="loading" v-else>
                    <el-empty description="暂无内容"></el-empty>
                  </div>
                  
              </el-tab-pane>
             
            </el-tabs>
            
          </div>
        </div>
        <div class="content-right">
          <div class="right-title">已选{{ searchDialogData.selectTitle }}</div>
          <div class="right-content">
            <el-tag
            class="content-tag"
              v-for="item in selectDataList"
              :key="item.id"
              closable
              type=""
              @close="handleClose(item)"
              >
              <span>{{item.labelName||item.peopleName}}</span>
            </el-tag>
            <!-- <div v-for="item in selectDataList">{{ item.labelName }}</div> -->
          </div>
          <div class="right-operation">
            <el-button size="mini" v-if="dataIdList.length!==0" type="danger" @click="dataIdList=[]">一键清空{{ searchDialogData.title }}</el-button>
          </div>
          <div style="padding:10px" v-if="dataIdList.length>0">
            <el-radio-group v-model="laberIdsAny" v-if="searchDialogData.title=='标签'">
              <el-radio :label="1">满足任意条件</el-radio>
              <el-radio :label="0">满足所有条件</el-radio>
            </el-radio-group>
            <el-radio-group v-model="peopleNamesAny" v-if="searchDialogData.title=='人物'">
              <el-radio :label="1">满足任意条件</el-radio>
              <el-radio :label="0">满足所有条件</el-radio>
            </el-radio-group>
            
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="searchClose()">取 消</el-button>
        <el-button type="primary" @click="searchConfirm()">确认检索</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'searchDialog',
  data() {
    return {
          loading: false,
          searchVisible: false,
          searchDialogData: {}, 
          listApi: '',
          keyword: '',
          name:'',
          dataList:[],
          filterDataList: [],
          dataIdList: [],
          laberIdsAny: 1,
          peopleNamesAny:1,
          selectDataList: [],
          selectPeopleNameList: [],
          peopleClassKey: ['全部', '政治', '商业', '娱乐', '公众'],
          peopleClassValue:'全部'
        }
  },
  methods: {
    checkboxChange(value) {
      console.log(value);
      // this.selectDataList = this.dataList.filter(item=>this.dataIdList.includes(item.id))

    },
    
    handleClick(tab, event) {
      console.log(tab.label, event);
      console.log(this.dataList);

      // this.selectDataList = this.dataList.filter(item=>this.dataIdList.includes(item.id))
      
        if (!this.name) {
          if (this.peopleClassValue=='全部') {
            this.filterDataList=this.dataList
          } else {
            this.filterDataList = this.dataList.filter(ele=>ele.peopleClass==this.peopleClassValue)
          }
        } else {
          if (this.peopleClassValue=='全部') {
            this.goSearch(1)
          } else {
            this.filterDataList = this.dataList.filter(ele=>ele.peopleName.indexOf(this.name)>-1&&ele.peopleClass==this.peopleClassValue)
            
          }
          // return item.labelName.indexOf(query.trim()) > -1;
        }
      
          // this.getList()
      
      
    },
    async getList() {
        this.loading=true
          let params = {
            // keyword: this.keyword,
            page: 0,
            pageSize: 999,
          }
          if (this.searchDialogData.title=='标签') {
            params.keyword = this.keyword
            
          } else {
            // if (this.peopleClassValue !== '全部')
            params.peopleClass = this.peopleClassValue !== '全部'?this.peopleClassValue:''
            params.name = this.name,
            params.fuzzySearch=true
          }
          let {data ,status,message} = await this.listApi(params)
      if (status) {
        this.loading = false
        if (this.searchDialogData.selectTitle=='标签') {
          if (!this.keyword) {
              this.dataList = data
              if (this.$parent.labelIds) {
                let idList = this.$parent.labelIds.split(',')
                this.dataIdList = idList.map(str => parseInt(str))
              }
              if (this.$parent.laberIdsAny) {
                this.laberIdsAny = this.$parent.laberIdsAny
              }
            }
            this.filterDataList = data
        }
        if (this.searchDialogData.selectTitle == '人物') {
          console.log(data);
          if (!this.name) { 
            this.dataList = data
          }
          this.filterDataList = data
        }
            
      } else {
        this.loading=false
            this.$message.warning(message)
          }
        },
      goSearch(flag) {
          if (flag) {
            if (!this.keyword &&!this.name) {
              this.$message.warning('搜索内容不能为空！')
              return
            }
            this.getList()
          } else {
            this.keyword = '';
            this.name = ''
            if (this.searchDialogData.title=='标签') {
              this.filterDataList = this.dataList 
            } else {
              this.peopleClassValue='全部'
              this.getList()
            }
          }
          
          
      },
      handleClose(item) {
        console.log(item);
        let idIndex = this.dataIdList.indexOf(item.id);
        console.log(idIndex);
        this.dataIdList.splice(idIndex, 1)
        // this.selectDataList = this.dataList.filter(item=>this.dataIdList.includes(item.id))

        console.log(this.dataIdList);
      },
      
      searchClose() {
          this.searchVisible = false 
      },
      searchConfirm() {
        if (this.searchDialogData.title=='标签') {
          console.log('已选数据', this.dataIdList);

          if (this.dataIdList.length>0) {
            let labelIds = this.dataIdList.join(',')
            this.searchDialogData.searchParams.labelIds = labelIds;
            this.searchDialogData.searchParams.laberIdsAny = this.laberIdsAny
            this.$parent.labelIds = labelIds;
            this.$parent.laberIdsAny = this.laberIdsAny;
          } else {
            this.searchDialogData.searchParams.labelIds = null;
            this.searchDialogData.searchParams.laberIdsAny = null;
            this.$parent.labelIds = '';
            this.$parent.laberIdsAny = null;
          }
        } else {
          if (this.searchDialogData.title=='人物') {
            this.selectDataList.forEach((ele) => {
              this.selectPeopleNameList.push(ele.peopleName) 
            })
            console.log('人物人物', this.selectPeopleNameList);
            this.$parent.peopleNames = this.selectPeopleNameList.join(',')
            if (this.dataIdList.length>0) {
              let peopleNames = this.selectPeopleNameList.join(',')
              this.searchDialogData.searchParams.peopleNames = peopleNames;
              this.searchDialogData.searchParams.peopleNamesAny = this.peopleNamesAny
              this.$parent.peopleIds = this.dataIdList.join(',')
              this.$parent.peopleNames = peopleNames;
              this.$parent.peopleNamesAny = this.peopleNamesAny;
            } else {
              this.searchDialogData.searchParams.peopleNames = null;
              this.searchDialogData.searchParams.peopleNamesAny = null;
              this.$parent.peopleIds = '';
              this.$parent.peopleNames = '';
              this.$parent.peopleNamesAny = null;
            }

          }
          // let peopleNames = 
        }
        
        if (this.$parent.searchFlag==1) {
          this.$parent.searchLoading = true;
          this.$parent.loading = true;
          this.$parent.picList = [];
        }
        if (this.$parent.searchFlag == 2) {
          this.$parent.videoLoading = true;
          this.$parent.videoSearchLoading = true;
          this.$parent.videoList = [];
        }
        this.searchDialogData.getDataList(this.searchDialogData.searchParams)
        this.searchVisible = false 
        this.selectDataList=[]
    },
    async acceptParams(params) {

      // 初始化数据操作
      this.keyword = ''
      this.name=''
      this.dataList=[]
      this.filterDataList = []
      this.dataIdList = []
      this.selectDataList = []
      // this.laberIdsAny=0
      this.selectPeopleNameList=[]
      this.searchDialogData = params
       
      this.listApi = params.listApi
      this.searchVisible = true;

      if (this.searchDialogData.title == '标签') this.getList()
      if (this.searchDialogData.title == '人物') {
        this.loading=true
          let params = {
            peopleClass : this.peopleClassValue !== '全部'?this.peopleClassValue:'',
            name :this.name,
            fuzzySearch:true,
            page: 0,
            pageSize: 999,
          }
          let {data ,status,message} = await this.listApi(params)
          if (status) {
            this.loading = false
              this.dataList = data
            this.filterDataList = data 
            if (this.$parent.peopleIds) {
              let idList = this.$parent.peopleIds.split(',')
              this.dataIdList = idList.map(str => parseInt(str))
              this.peopleNamesAny = this.$parent.peopleNamesAny||this.peopleNamesAny
            }  
          } else {
            this.loading=false
            this.$message.warning(message)
          }
      }
      
      
    },
        
  },
  watch: {
    dataIdList(){
      console.log('数据变了');
      // console.log(this.dataIdList);
      
      this.selectDataList = this.dataList.filter(item=>this.dataIdList.includes(item.id))
      console.log(this.selectDataList);
      
    }
  }

}
</script>

<style lang="scss" scoped>
.main-content{
  height:600px;
  margin:0 60px;
  width: 90%;
  // background-color: pink;
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  .content-left{
    width: 70%;
    height: 100%;
    padding:0 50px;
    // background: orange;
    border-radius: 20px;
    box-sizing: border-box;
    border: 2px solid #666;
    box-shadow: 2px 2px 2px 2px;
    .left-title{
      height: 50px;
      display: flex;
      font-size: 20px;
      color: black;
      font-weight: bold;
      justify-content: center;
      align-items: center;
    }
    .left-search{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
    }
    .left-content{
      margin-top: 25px;
      width: 100%;
      height: 450px;
      overflow-y: scroll;
      // background-color: pink;
      .el-tabs__header{
        width: fit-content !important;
      }
      .people-class{
        height: 380px;
        width: 100%;
        // background-color: pink;
        // overflow-y: scroll;
      }
      .left-content-checkbox-group{
        height: 500px;
        // background-color: pink;
        overflow-y: scroll;
        // display: grid;
        // grid-template-columns: 1fr 1fr 1fr;

        .left-content-checkbox{
          // width: 25%;
          min-height: 30px;
        }
      }

      
    }
  }
  .content-right{
    width: 30%;
    // background-color: skyblue;
    height: 100%;
    border-radius: 20px;
    box-sizing: border-box;
    border: 2px solid #666;
    margin-left: 6px;
    box-shadow: 2px 2px 2px 2px;
    .right-title{
      height: 50px;
      display: flex;
      font-size: 20px;
      color: black;
      font-weight: bold;
      justify-content: center;
      align-items: center;
    }
.right-content{
  width: 95%;
  margin:0 10px;
  height: 430px;
  // background-color: skyblue;
  overflow-y: scroll;
  .content-tag{
      max-width: 300px;
      white-space: break-spaces;
      height: auto;
      margin-bottom: 10px;
      margin-right: 5px;

  }
  :deep(.el-tag){
    white-space: break-spaces
  }
  
}
.right-operation{
  margin:10px;
  height: 30px;
  display: flex;
  
  justify-content: flex-end;
}
    
  }
}
</style>

<style lang="scss">
</style>